export function formatCurrency(value: number | string, maximumFractionDigits = 0): string {
  return Number(value).toLocaleString(`en-US`, {
    style: `currency`,
    currency: `USD`,
    maximumFractionDigits,
  })
}
